import commonActionHeaders from './common-action-headers';

export default [
  {
    text: 'id',
    value: 'id',
    visible: true,
    sortable: true,
    hasLink: false,
  },
  {
    text: 'Type',
    value: 'type',
    translated_name: 'action_type_id',
    visible: true,
    sortable: true,
    hasLink: false,
  },
  {
    text: 'Task Assignee/Sent From',
    value: 'assigned_user',
    translated_name: 'assigned_user_id',
    visible: true,
    sortable: true,
    hasLink: false,
  },
  {
    text: 'Template',
    value: 'template_name',
    translated_name: 'template_id',
    visible: true,
    sortable: false,
    hasLink: false,
  },
  {
    text: 'Email Subject/Text Body',
    value: 'template_subject',
    visible: true,
    sortable: false,
    hasLink: false,
  },
  {
    text: 'Timing Type',
    value: 'timing_type',
    visible: false,
    sortable: true,
    hasLink: false,
  },
  {
    text: 'Pending Contacts',
    value: 'pending_contacts',
    translated_name: 'pending_contacts',
    visible: true,
    sortable: false,
    hasLink: false,
  },
  {
    text: 'Notes',
    value: 'notes',
    visible: true,
    sortable: true,
    hasLink: false,
  },
  ...commonActionHeaders,
  {
    text: '',
    value: 'assigned_user_id',
    visible: false,
    sortable: true,
    hasLink: false,
  },
];
